import config from 'shared/config';
import { FunnelType, WireFunnelType } from 'scenes/common/types';
import { MotorFunnelState, MotorFlowType } from 'scenes/motor/flows/types';
import {
  WireFlowTypeName,
  WireFlowTypeNumber,
} from 'scenes/motor/analytics/types';
import {
  getAppliedCampaignId,
  getColesCampaignCode,
  getPrefilledCampaignId,
  getPrefilledPromoCode,
  getPromoCode,
} from 'scenes/motor/selectors';

const toFlowName = (flowType: MotorFlowType): WireFlowTypeName => {
  switch (flowType) {
    case MotorFlowType.QuoteDetails:
      return WireFlowTypeName.QuoteDetails;
    case MotorFlowType.AddDriver:
      return WireFlowTypeName.AddDriver;
    case MotorFlowType.CoverOptions:
      return WireFlowTypeName.CoverOptions;
    case MotorFlowType.PaymentDetails:
      return WireFlowTypeName.PaymentDetails;
    case MotorFlowType.PolicyDetails:
      return WireFlowTypeName.PolicyDetails;
    case MotorFlowType.AddPolicyHolder:
      return WireFlowTypeName.AddPolicyHolder;
    case MotorFlowType.ReviewDriver:
      return WireFlowTypeName.RetrieveQuote;
    case MotorFlowType.ReviewDetails:
      return WireFlowTypeName.RetrieveQuote;
    default:
      return WireFlowTypeName.Unknown;
  }
};

const toFlowNumber = (flowType: MotorFlowType): WireFlowTypeNumber => {
  switch (flowType) {
    case MotorFlowType.QuoteDetails:
      return WireFlowTypeNumber.QuoteDetails;
    case MotorFlowType.AddDriver:
      return WireFlowTypeNumber.AddDriver;
    case MotorFlowType.CoverOptions:
      return WireFlowTypeNumber.CoverOptions;
    case MotorFlowType.PaymentDetails:
      return WireFlowTypeNumber.PaymentDetails;
    case MotorFlowType.PolicyDetails:
      return WireFlowTypeNumber.PolicyDetails;
    case MotorFlowType.AddPolicyHolder:
      return WireFlowTypeNumber.AddPolicyHolder;
    case MotorFlowType.ReviewDriver:
      return WireFlowTypeNumber.RetrieveQuote;
    case MotorFlowType.ReviewDetails:
      return WireFlowTypeNumber.RetrieveQuote;
    default:
      return WireFlowTypeNumber.Unknown;
  }
};

export const toPageName = (state: MotorFunnelState) =>
  `gi:${WireFunnelType.Motor}:${toFlowName(state.flow)}:${state.step}`;

const toPageUrl = (state?: MotorFunnelState) =>
  `${window.location.origin}${config.junctionPath}/${FunnelType.Motor}/${
    state?.step || ''
  }`;

const toStepName = (state: MotorFunnelState) =>
  `${WireFunnelType.Motor}:${toFlowNumber(state.flow)}:${state.step}`;

const toPromoCodeManual = (state?: MotorFunnelState) => {
  if (!state) {
    return '';
  }

  const promoCode = getPromoCode(state);
  return getPrefilledPromoCode(state).toUpperCase() !== promoCode.toUpperCase()
    ? promoCode
    : '';
};

export const toWirePage = (state?: MotorFunnelState) => ({
  pageName: state ? toPageName(state) : '',
  pageUrl: toPageUrl(state),
  siteSection: FunnelType.Motor,
  siteServer: window.location.hostname,
  stepName: state ? toStepName(state) : '',
  timeStamp: `${new Date().valueOf()}`,
  colesCampaignCode: state ? getColesCampaignCode(state) : '',
  campaignCodePrefilled: state ? getPrefilledCampaignId(state) : '',
  campaignCodeApplied: state ? getAppliedCampaignId(state) : '',
  promoCodePrefilled: state ? getPrefilledPromoCode(state) : '',
  promoCodeManual: toPromoCodeManual(state),
});
